module.exports = __webpack_public_path__ + "media/images/safeAndSound-logo-02783977eb9e40c4fd52ac7b6cf96ebd.svg";